// Source: https://dev.azure.com/azurereleasemanager/londonedu-alumnidigitalexperience/_git/hivebrite-tooling?path=/hivebrite-bookmarklets/src/user-data/generic-field-editor.js&version=GBmain&line=298&lineEnd=432&lineStartColumn=5&lineEndColumn=7&lineStyle=plain&_a=contents
export const PROGRAMME_OF_STUDY_OPTIONS = [
  "ADP",
  "DEMBAJ",
  "DEMBAS",
  "DLEMBA",
  "EMBA",
  "EMBADJ",
  "EMBADS",
  "EMBAG",
  "EMBAGA",
  "EMBALJ",
  "EMBALS",
  "HKU",
  "IEMP",
  "IEP",
  "IMP",
  "JEMBA",
  "MAM",
  "MBA",
  "MFA",
  "MIFFT",
  "MIFPT",
  "MIM",
  "MSC",
  "PHD",
  "SEMBA",
  "SEP",
  "SLN",
]
  .map((value) => ({ value }))
  .sort();

const MIN_YEAR = 1966;

export const generateYearOptions = (): { value: string }[] => {
  const maxYear = new Date().getFullYear() + 2;
  const years: { value: string }[] = [];
  for (let year = maxYear; year >= MIN_YEAR; year--) {
    years.push({ value: String(year) });
  }
  return years;
};
